module.exports = __webpack_public_path__ + "static/media/stu.58f303e1.jpg";